import { render, staticRenderFns } from "./editColButton.vue?vue&type=template&id=0df7ca5e"
import script from "./editColButton.vue?vue&type=script&lang=js"
export * from "./editColButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports